import { Link } from "react-router-dom";
import { FlaskConical, Sprout, PhoneCall } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function Pesticide() {
  const { t } = useLang();
  return (
    <div className="max-w-2xl mx-auto mt-10" data-testid="pesticide-coming-soon">
      <div className="sf-card p-10 text-center">
        <div className="h-16 w-16 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center mx-auto">
          <FlaskConical className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900 mt-5">{t("pesticide")} — {t("comingSoon")}</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">
          Online pesticide ordering will be available soon. Meanwhile, you can continue placing fertilizer orders,
          or call your sales representative for current pesticide requirements and rates.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-6">
          <Link to="/customer/fertilizer" className="sf-btn-primary" data-testid="pesticide-go-fertilizer-btn">
            <Sprout className="h-4 w-4" /> {t("fertilizer")}
          </Link>
          <a href="tel:+919000000001" className="sf-btn-outline" data-testid="pesticide-call-btn">
            <PhoneCall className="h-4 w-4" /> Call for Pesticide
          </a>
        </div>
      </div>
    </div>
  );
}
